import React from "react";
function Social() {
  return (
    <div className="social">
      <a
        href="https://www.linkedin.com/in/abhishek-jha-695b8b203/"
        className="social-icon"
        target={"_blank"}
      >
        <i className="fa-brands fa-linkedin"></i>
      </a>

      <a
        href="https://www.instagram.com/mr_madhav_jha/"
        className="social-icon"
        target={"_blank"}
      >
        <i className="fa-brands fa-instagram"></i>
      </a>

      <a
        href="https://github.com/Abhishekjha36"
        className="social-icon"
        target={"_blank"}
      >
        <i className="fa-brands fa-github"></i>
      </a>
    </div>
  );
}

export default Social;
